import { Component, Input } from '@angular/core';
import { SanitizerPipe } from 'src/app/shared/pipes';

@Component({
    selector: 'app-redirection-by-arrived-day',
    standalone: true,
    imports: [SanitizerPipe],
    templateUrl: './redirection-by-arrived-day.component.html',
    styleUrl: './redirection-by-arrived-day.component.scss',
})
export class RedirectionByArrivedDayComponent {
    @Input() arrivedDay: string | undefined = '';
    @Input() redirectionUrl!: string;
}
